module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [(false) ? _c('div', {
    staticClass: "word"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n        合作伙伴\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("\n        十年间，极客邦科技已经服务超过25000家中国和全球企业，服务的行业包括了互联网、金融、银行、证券、制造、快消、零售、汽车、医疗、教育等领域。\n      ")])]) : _vm._e()]), _vm._v(" "), _c('com-prodserv', {
    attrs: {
      "data": _vm.prodservs
    }
  }), _vm._v(" "), _c('com-message', {
    attrs: {
      "messages": _vm.messages
    }
  }), _vm._v(" "), _c('com-partner', {
    attrs: {
      "partners": _vm.partners
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d870ea0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/partner/partner.vue
// module id = 454
// module chunks = 1